import React from 'react';
import { SectionHelper } from '@wix/design-system';
import { useTranslation } from 'react-i18next';
/* eslint-disable-next-line import/no-extraneous-dependencies -- resolved via tsconfig paths to sibling package source */
import { CreatePasskeyErrorCode } from '@wix/webauthn-management';
import { dataHooks } from '../../../dataHooks';
import { getPasskeyEnrollErrorKey } from './keys';

export interface PasskeyEnrollErrorProps {
  errorCode: CreatePasskeyErrorCode;
  onClose: () => void;
}

export function PasskeyEnrollError(props: PasskeyEnrollErrorProps) {
  const { t } = useTranslation();
  const messageKey = getPasskeyEnrollErrorKey(props.errorCode);

  return (
    <SectionHelper
      dataHook={dataHooks.postLogin.passkeyEnroll.errorMessage}
      skin="danger"
      showCloseButton
      onClose={props.onClose}
      showPrefixIcon
    >
      {t(messageKey)}
    </SectionHelper>
  );
}
